// Web3Forms configuration — the contact form posts directly from the browser
// to Web3Forms; there is no backend in the static build. The access key is
// INTENTIONALLY public in the page code: it can only send mail to the account
// owner's registered address (set in the Web3Forms dashboard), never anywhere
// else, so exposing it is by design. The recipient address is controlled by
// the Web3Forms account and is never written in this codebase.
export const WEB3FORMS_ENDPOINT = "https://api.web3forms.com/submit";
export const WEB3FORMS_ACCESS_KEY = "8c26a31e-ca21-4daa-a4d3-218a86765344";
